import { ActionTriggerDto } from "./actionTriggers/actionTriggerDto";
import { FieldDto } from "./formFields/fieldDto";

class FormDto {

    public id: string;

    public title: string;

    public fields: FieldDto[] = [];

    public actionTriggers: ActionTriggerDto[] = [];
}

export { FormDto };